import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const REMOVE_FAVORITE_MUTATION = gql`
  mutation removeFavorite(
    $documentsVersion: [DocumentVersionInput!]!
  ) {
    removeFavorite(documentsVersion: $documentsVersion)  {
      documentId
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RemoveFavoriteMutation extends Mutation<RootMutation> {
  document = REMOVE_FAVORITE_MUTATION;
}
